import { render, staticRenderFns } from "./AddKeywordModal.vue?vue&type=template&id=336888b7"
import script from "./AddKeywordModal.vue?vue&type=script&lang=js"
export * from "./AddKeywordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports